var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "291px",
    height: "244px",
    viewBox: "0 0 291 244",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.630741,1.3716364 C150.745288,2.04363541 151.679058,2.97740516 152.351057,4.09195162 L215.727389,109.205005 L289.685952,231.869259 C291.967298,235.652993 290.749371,240.569711 286.965637,242.851057 C285.718911,243.602751 284.290701,244 282.834896,244 L8.1651043,244 C3.7468263,244 0.165104295,240.418278 0.165104295,236 C0.165104295,234.544194 0.56235323,233.115984 1.31404773,231.869259 L138.648943,4.09195162 C140.930289,0.308217566 145.847007,-0.909709044 149.630741,1.3716364 Z M145,182 C135.611159,182 128,189.611159 128,199 C128,208.388841 135.611159,216 145,216 C154.388841,216 162,208.388841 162,199 C162,189.611159 154.388841,182 145,182 Z M145,72 C135.611159,72 128,79.6111593 128,89 L128,89 L128,150 C128,159.388841 135.611159,167 145,167 C154.388841,167 162,159.388841 162,150 L162,150 L162,89 C162,79.6111593 154.388841,72 145,72 Z",
    id: "Combined-Shape",
    fill: "#453E1D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.3c1eaa76e706e72758415d70a30a606a.svg";
export { ForwardRef as ReactComponent };